export const projectsData = [
    {
        title: 'Portfolio',
        description: 'Well, the website you are currently on! A static site presenting my resume, my projects and my contact information.',
        tags: ['JS', 'HTML/CSS'],
        githubLink: 'https://github.com/cdelahaye/portfolio',
        date: '10/23',
        id: 'Portfolio'
    },
];

